var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.502,
    height: 22.386,
    viewBox: "0 0 72.502 22.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visa",
    d: "M67.731.418H63.182a2.932,2.932,0,0,0-3.092,1.8L51.343,22.1h6.183s1.01-2.672,1.238-3.258l7.555.007c.175.757.721,3.243.721,3.243h5.468ZM60.464,14.395c.488-1.248,2.346-6.062,2.346-6.062-.031.06.481-1.255.786-2.071L64,8.135s1.128,5.178,1.365,6.263h-4.9Zm-8.705.6c-.044,4.5-4.068,7.413-10.263,7.413a18.648,18.648,0,0,1-6.565-1.154L35.76,16.4l.758.345a12.335,12.335,0,0,0,5.545,1.138c1.694,0,3.508-.665,3.524-2.118.011-.95-.759-1.629-3.053-2.691-2.239-1.039-5.2-2.778-5.165-5.894C37.409,2.965,41.511.023,47.34.023a15.161,15.161,0,0,1,5.278.911l-.8,4.7-.529-.251a10.836,10.836,0,0,0-4.41-.83c-2.306,0-3.378.961-3.378,1.865-.012,1.016,1.25,1.682,3.311,2.69,3.4,1.544,4.974,3.423,4.95,5.886ZM.007.641.083.208H9.218a2.37,2.37,0,0,1,2.568,1.761l1.987,9.586C11.82,6.543,7.116,2.371.007.641ZM26.656.413,17.379,22.063l-6.234.008L5.864,3.984a23.2,23.2,0,0,1,8.168,8.99l.615,2.239L20.408.416h6.246ZM29.033.4h5.9L31.241,22.087h-5.9Z",
    transform: "translate(-0.007 -0.022)",
    fill: "#1d1d1b",
    fillRule: "evenodd",
    opacity: 0.52
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.8c02d979e9852a2e34948eec3bc75938.svg";
export { ForwardRef as ReactComponent };